package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable

// El navegador no permite re-pedir el permiso programáticamente: el usuario lo cambia desde el
// candado del sitio. Por eso no ofrecemos botón (sólo el mensaje).
@Composable
actual fun rememberMediaPermissionAction(withVideo: Boolean, onResolved: () -> Unit): (() -> Unit)? = null
